import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Popup } from 'semantic-ui-react';

const Revert = (props) => {
    const {
        onChange,
        name,
        originalValue,
        standAlone,
        showWarning,
        className
    } = props;

    const revertValue = () => {
        if (showWarning && !confirm("Bent u zeker dat u de originele waarde wilt terug zetten?"))
            return;

        onChange({
            target: {
                name: name,
                value: originalValue
            }
        });
    };

    const undoClassName = className || "c-undo";

    return !standAlone ?
        <Popup trigger={<a className={classnames({ [undoClassName]: true })} onClick={revertValue}>
            <i className="fa fa-fw fa-undo"></i>
        </a>} content={'Keer terug naar vorige situatie'} />
        : <a onClick={revertValue}>
            <i className="fa fa-fw fa-undo"></i>
        </a>;
};

Revert.propTypes = {
    onChange: PropTypes.func,
    name: PropTypes.string,
    originalValue: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.array
    ]),
    standAlone: PropTypes.bool,
    showWarning: PropTypes.bool,
    className: PropTypes.string
};

export default Revert;